import React from 'react';
import PatientInfoContact, { PatientInfoContactProps } from './PatientInfoContact';
import ThemedComponent from '../../theme/ThemedComponent';

export function PatientInfoContactWrapper({
  alertService,
  patient,
  capsuleEligibilityCheckInProgress,
  capsuleDeliveryAvailable,
}: PatientInfoContactProps): React.JSX.Element {
  return (
    <ThemedComponent>
      <PatientInfoContact
        alertService={alertService}
        patient={patient}
        capsuleEligibilityCheckInProgress={capsuleEligibilityCheckInProgress}
        capsuleDeliveryAvailable={capsuleDeliveryAvailable}
      />
    </ThemedComponent>
  );
}

export default PatientInfoContactWrapper;
